<template>
  <method-config-component
    :search-params="searchParams"
    :config-name-list="configNameList"
  />
</template>

<script>
import MethodConfigComponent from '../components/methodConfigComponent.vue'
export default {
  components: { MethodConfigComponent },
  data() {
    return {
      searchParams: {
        type: 3
      },
      configNameList: [
        'CASH_REFUND',
        'OTHER',
        'CREDIT_REFUND',
        'TRANSFER_REFUND',
        'DEBT_PAYMENT',
        'PREPAID_CARD_PAYMENT'
      ]
    }
  }
}
</script>
